import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a12c83e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1 /* HOISTED */))
const _hoisted_2 = { style: {"margin-left":"4px"} }
const _hoisted_3 = { class: "flex align-items-center" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "p-fluid formgrid grid" }
const _hoisted_8 = { class: "flex align-items-center mb-1" }
const _hoisted_9 = { for: "" }
const _hoisted_10 = { class: "p-inputgroup flex-2" }
const _hoisted_11 = {
  key: 0,
  class: "p-inputgroup-addon"
}
const _hoisted_12 = {
  key: 2,
  class: "p-inputgroup-addon"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi pi-times" }, null, -1 /* HOISTED */))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SaveSearch = _resolveComponent("SaveSearch")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Panel, {
      class: "field col-12 md:col-12",
      toggleable: true,
      collapsed: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_1,
          _createTextVNode(),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t('bar.title')), 1 /* TEXT */),
          _createCommentVNode("\r\n                    <i v-badge=\"2\" class=\"pi pi-search p-overlay-badge\" style=\"font-size: 2rem\" @click=\"openSaveSearch\"/>\r\n                    ")
        ])
      ]),
      icons: _withCtx(() => [
        (_ctx.showBtnSearch && _ctx.dataFilter.length > 0)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              id: "buscar",
              label: _ctx.t('btn.buscar'),
              icon: "pi pi-search",
              class: "mr-2 p-button-rounded p-button-primary p-button-outlined",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('buscarDatos')))
            }, null, 8 /* PROPS */, ["label"]))
          : _createCommentVNode("v-if", true),
        (_ctx.showBtnClear && _ctx.dataFilter.length > 0)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              id: "limpiarfiltros",
              label: _ctx.t('btn.limpiar'),
              icon: "pi pi-trash",
              class: "mr-2 p-button-secondary p-button-rounded",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearFilterData()))
            }, null, 8 /* PROPS */, ["label"]))
          : _createCommentVNode("v-if", true),
        (_ctx.showBtnCloseTabs && _ctx.dataFilter.length > 0)
          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
              key: 2,
              id: "cerrarpestanias",
              label: _ctx.t('btn.cerrar'),
              icon: "pi pi-times",
              class: "mr-2 p-button-outlined p-button-secondary p-button-rounded",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closealltabs')))
            }, null, 8 /* PROPS */, ["label"])), [
              [_directive_tooltip, _ctx.t('tooltip.cerrar')]
            ])
          : _createCommentVNode("v-if", true),
        (_ctx.showBtnSaveSearch && _ctx.dataFilter.length > 0)
          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
              key: 3,
              id: "saveSearch",
              rounded: "",
              severity: "secondary",
              label: _ctx.t('btn.saveSearch'),
              icon: "pi pi-save",
              class: "mr-2",
              model: _ctx.savedSearchs,
              onClick: _ctx.openSaveSearch
            }, null, 8 /* PROPS */, ["label", "model", "onClick"])), [
              [_directive_tooltip, _ctx.t('tooltip.saveSearch')]
            ])
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.selectedSearch,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSearch) = $event)),
          options: _ctx.getData,
          filter: "",
          optionLabel: "label",
          optionGroupLabel: "label",
          optionValue: "value",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectQuestion($event))),
          optionGroupChildren: "items",
          placeholder: "Selecciona un filtro",
          class: "w-full md:w-14rem mr-5"
        }, {
          optiongroup: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("i", {
                class: _normalizeClass(slotProps.option.icon)
              }, null, 2 /* CLASS */),
              _createElementVNode("div", _hoisted_4, _toDisplayString(slotProps.option.label), 1 /* TEXT */)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "options"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFilter, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: (_ctx.dataBaseId + '.' + item.field?.tableName + '.' + item.field?.field),
                  class: "field col-12 md:col-3"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("i", {
                      class: _normalizeClass([_ctx.tablas.find(x => x.tableName == item.field.tableName)?.idIcon ?? 'pi pi-list', "ml-1 mr-2"])
                    }, null, 2 /* CLASS */), [
                      [_directive_tooltip, item.field.tableName]
                    ]),
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.translateFieldLabel(item)), 1 /* TEXT */),
                    _createVNode(_component_Dropdown, {
                      disabled: !_ctx.isFilterVisible(item.field),
                      modelValue: item.filter,
                      "onUpdate:modelValue": ($event: any) => ((item.filter) = $event),
                      filter: "",
                      options: _ctx.getCatalogData(_ctx.CatalogTypeConst.FILTROBUSQUEDA),
                      optionLabel: "description",
                      optionValue: "id",
                      class: "wrap-input ml-1"
                    }, null, 8 /* PROPS */, ["disabled", "modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createCommentVNode("\r\n                                <span class=\"p-inputgroup-addon\">\r\n                                    <InputSwitch v-model=\"item.seleccionado\" /> \r\n                                    <Checkbox v-model=\"item.seleccionado\" :binary=\"true\" />\r\n                                    \r\n                                </span>\r\n"),
                    (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item.field, _ctx.SqlTypesConst.DATE))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Desde"))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item.field, _ctx.SqlTypesConst.DATE))
                      ? (_openBlock(), _createBlock(_component_Calendar, {
                          key: 1,
                          showButtonBar: true,
                          modelValue: item.rangeDateTime.from,
                          "onUpdate:modelValue": ($event: any) => ((item.rangeDateTime.from) = $event),
                          onContextmenu: _ctx.showMenuFilter
                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onContextmenu"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item.field, _ctx.SqlTypesConst.DATE))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Hasta"))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item.field, _ctx.SqlTypesConst.DATE))
                      ? (_openBlock(), _createBlock(_component_Calendar, {
                          key: 3,
                          showButtonBar: true,
                          modelValue: item.rangeDateTime.to,
                          "onUpdate:modelValue": ($event: any) => ((item.rangeDateTime.to) = $event),
                          onContextmenu: _ctx.showMenuFilter
                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onContextmenu"]))
                      : (_ctx.isType(item.field, _ctx.SqlTypesConst.VARCHAR) && _ctx.isCatalogType(item.field))
                        ? (_openBlock(), _createBlock(_component_MultiSelect, {
                            key: 4,
                            modelValue: item.valueList,
                            "onUpdate:modelValue": ($event: any) => ((item.valueList) = $event),
                            options: _ctx.getCatalogData(item.field?.catalogTypeId),
                            filter: true,
                            optionLabel: "description",
                            optionValue: "id",
                            onContextmenu: _ctx.showMenuFilter
                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "onContextmenu"]))
                        : (_ctx.isType(item.field, _ctx.SqlTypesConst.BIT))
                          ? (_openBlock(), _createBlock(_component_InputSwitch, {
                              key: 5,
                              modelValue: item.value,
                              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                              class: "mr-2",
                              onContextmenu: _ctx.showMenuFilter
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onContextmenu"]))
                          : (_openBlock(), _createBlock(_component_InputText, {
                              key: 6,
                              modelValue: item.value,
                              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                              maxlength: item.field?.longitud ?? 25,
                              onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.$emit('buscarDatos')), ["enter"])),
                              onContextmenu: _ctx.showMenuFilter
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "maxlength", "onContextmenu"])),
                    _createCommentVNode("\r\n                                <span class=\"p-inputgroup-addon\" >\r\n                                    <i class=\"pi pi pi-search\" @click=\"visibleFindTable=true\"></i>\r\n                                </span>\r\n                                "),
                    _createElementVNode("span", {
                      class: "p-inputgroup-addon",
                      onClick: ($event: any) => (_ctx.removeQuestion(_ctx.dataFilter[index].field))
                    }, _hoisted_15, 8 /* PROPS */, _hoisted_13)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            (_ctx.dataFilter.length == 0)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  closable: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("No hay filtros seleccionados")
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_ContextMenu, {
      ref: "menuFilter",
      model: _ctx.getDataContext
    }, null, 8 /* PROPS */, ["model"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.visibleFindTable,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visibleFindTable) = $event)),
      modal: "",
      header: "Header",
      style: { width: '50vw' }
    }, {
      default: _withCtx(() => [
        _hoisted_16,
        _hoisted_17
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    _createVNode(_component_OverlayPanel, { ref: "opSaveSearch" }, {
      default: _withCtx(() => [
        _createVNode(_component_SaveSearch, {
          container: _ctx.container,
          applicationId: _ctx.applicationId,
          applicationVersion: _ctx.applicationVersion,
          componentId: _ctx.componentId,
          dataFilter: _ctx.dataFilter,
          "onUpdate:dataFilter": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dataFilter) = $event)),
          compDataSource: _ctx.compDataSource,
          catalogosData: _ctx.catalogosData,
          "onClick:setSearch": _ctx.loadSearch
        }, null, 8 /* PROPS */, ["container", "applicationId", "applicationVersion", "componentId", "dataFilter", "compDataSource", "catalogosData", "onClick:setSearch"])
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */)
  ]))
}